/**
 * HTTP request layer
 * if auth is required return patched axios instance(with access token in headers)
 * else return clear axios instance
 */

import axios from 'axios'
import { STAT_API_URL } from '../.env'

export default class HttpStat {
  constructor (status) {
    //this.isAuth = status && status.auth ? status.auth : false
    this.instance = axios.create({
      baseURL: STAT_API_URL
    })
  
    return this.init()
  }

  init () {
    return this.instance
  }
}
